import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import { toJS } from 'mobx';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IMenuStore,
} from '../../mobx-store/storeInterfaces/menuCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditMenu.module.scss';

interface IProps extends WithSnackbarProps {
  menuStore: IMenuStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loadingCategory: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
}

@inject('menuStore')
@inject('countryStore')
@observer
class AddEditMenu extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  restaurantId = -1;

  categoryId = -1;

  menuId = -1;

  lastHistory = -1;

  pageTitle = '';

  categoryFormTitle = '';

  menuSchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    this.restaurantId = props.match.params.restaurantId;
    this.categoryId = props.match.params.categoryId;
    if (props.match.params.menuId) {
      this.isNew = false;
      this.menuId = props.match.params.menuId;
      this.pageTitle = translate('editMenuPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addMenuPageTitle', {
      });
    }
    this.initMenuSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.categoryFormTitle = translate('addMenuPageFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      if (!this.isNew) {
        this.props.menuStore.getMenuById(this.menuId, languageCodes.english)
          .then(() => {
            this.updateStateWithMenuData();
          }).catch(() => {
            this.setState({
              loadingCategory: false,
            });
          });
      }
    }
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  handelLanguageChange = (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      this.getRestaurantMenu(langCode);
    }
  };

  initMenuSchema = () => {
    this.menuSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      images: Yup.array().required('Required'),
      price: Yup.number().required('Required'),
      description: Yup.string().required('Required'),
      thumbnail: Yup.array().required('Required'),
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: languageCodes.english,
      processing: false,
      loadingManagedCountries: true,
      loadingCategory: !this.isNew,
      formFields: [
        {
          name: 'title',
          label: this.isNew && this.isEgypt ? translate('addMenuPageFormArabicTitle', {
          }) : translate('addMenuPageFormEnglishTitle', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'price',
          label: translate('addMenuPageFormPrice', {
          }),
          type: 'number',
          filedType: 'InputField',
        },
        {
          name: 'description',
          label: this.isNew && this.isEgypt ? translate('addMenuPageFormArabicDescription', {
          }) : translate('addMenuPageFormDescription', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'thumbnail',
          label: translate('addMenuPageFormImage', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'image/*',
          size: 2000,
        },
        {
          name: 'images',
          label: translate('addMenuPageFormImage', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: false,
          accept: 'image/*',
          size: 2000,
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handelSubmit = (values: any): void => {
    const {
      countryStore, menuStore, history,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      menuStore.createMenu(this.categoryId, values)
        .then((menuId) => {
          if (this.isEgypt) {
            history.push(`${menuId}/edit`);
          } else {
            history.go(this.lastHistory);
          }
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 8000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    } else {
      menuStore.updateMenu(values, this.menuId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
          history.go(this.lastHistory);
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    }
  };

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithMenuData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: toJS(this.props.menuStore.selectedMenu[field.name]),
      });
    }
    this.setState({
      formFields: formFieldsWithData, loadingCategory: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loadingCategory || this.state.loadingManagedCountries
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.categoryFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.menuSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      menuStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.initState(false);
    this.submitButton = this.getSubmitButton();

    if (!this.isNew) {
      menuStore.getMenuById(this.menuId, languageCodes.english)
        .then(() => {
          this.updateStateWithMenuData();
        }).catch(() => {
          this.setState({
            loadingCategory: false,
          });
        });
    }
    this.setState({
      loadingManagedCountries: false,
    });
  }

  getRestaurantMenu = (langCode: string) => {
    this.setState({
      loadingCategory: true,
    });
    this.props.menuStore.getMenuById(this.menuId, langCode)
      .then(() => {
        this.updateStateWithMenuData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loadingCategory: false,
        });
      });
  };
}

export default withRouter(AddEditMenu);
